/**
 * <arcero-bestsellers-rail> — manual horizontal scroll only, no autoplay.
 * Prev/next buttons and left/right arrow keys (when the track is focused)
 * scroll by one card-width; buttons disable at each scroll boundary.
 * Touch/mouse drag-scroll is native overflow-x: auto — nothing to wire up.
 */
class ArceroBestsellersRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-arcero-rail-track]');
    this.prevButton = this.querySelector('[data-arcero-rail-prev]');
    this.nextButton = this.querySelector('[data-arcero-rail-next]');
    this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.track) return;

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scrollByStep(-1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scrollByStep(1));
    }

    this.track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') this.scrollByStep(1);
      if (event.key === 'ArrowLeft') this.scrollByStep(-1);
    });

    this.track.addEventListener('scroll', () => this.syncButtons(), { passive: true });
    window.addEventListener('resize', () => this.syncButtons());

    this.syncButtons();
  }

  scrollByStep(direction) {
    const firstItem = this.track.firstElementChild;
    const step = firstItem ? firstItem.getBoundingClientRect().width + 16 : 320;
    const multiplier = window.innerWidth > 900 ? 2 : 1;

    this.track.scrollBy({
      left: step * direction * multiplier,
      behavior: this.reduceMotionQuery.matches ? 'auto' : 'smooth',
    });
  }

  syncButtons() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;

    if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 2;
    if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= max;
  }
}

customElements.define('arcero-bestsellers-rail', ArceroBestsellersRail);
